import { render, staticRenderFns } from "./taskGraph.vue?vue&type=template&id=52ff2c96&"
import script from "./taskGraph.vue?vue&type=script&lang=js&"
export * from "./taskGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports